export default {
    delete_message_after_send: 'Delete message directly after sending',
    delete_message_after_send_tip: 'Chat history will be deleted.Use for new customer promotion.',
    buttonNoSend: 'Important Notice: Discontinuation of WhatsApp Button Feature',
    buttonSend: 'Important Notice: Activation of WhatsApp Button Function.',
    period_t: '.',
    semicolon_t: ';',
    colon_t: ':',
    help_center_t: 'Help Center',
    how_to_t: 'How to use',
    leave_a_t: 'Leave a Review ',
    support_t: 'Support',
    more_free_t: 'More Tools',
    share_t: 'Share',
    send_messages_t: 'Simple',
    whatsapp_numbers_t: 'WhatsApp Numbers',
    million_leads_t: 'Million Leads For Free!',
    country_code_t:
        'Country code in front, separate using comma, like: +8613135587131,+8619197646821',
    message_text_t: 'Message Text',
    select_template_t: 'Select template',
    save_as_t: 'Save as template',
    help_there_t:
        'Hello,there is a WhatsApp bulk message send tool I want to recommend to you. 🚀\n\n' +
        '1️⃣ If you are interested, please reply "Yes" and I will show you more details.\n' +
        '2️⃣ If it disturbs you, please reply "No" and I will not send you any more messages.\n',
    sending_settings_t: 'Sending Settings',
    messages_will_t: 'Messages will be sent randomly from this interval.',
    sending_interval_t: 'Sending interval',
    seconds_t: 'seconds',
    send_t: 'Send',
    sending_t: 'sending...',
    send_messages_pro_t: 'Pro',
    whatsapp_numbers_excel_t: "WhatsApp Number's Excel",
    download_excel_template_t: 'Download Excel Template',
    fill_it_t: 'Fill It',
    upload_excel_t: 'Upload Excel',
    how_to_use_t: 'How to use',
    excel_template_t: 'Excel Template',
    upload_excel_btn_t: 'Upload Excel',
    send_to_t: 'Send to group members 1 by 1',
    send_to_label: 'Send to label members 1 by 1',
    no_data_t: 'No Data',
    select_joined_send_t: 'Select joined group to send message',
    select_joined_send_label: 'Select the label you have created',
    apologize_for_t: 'Apologize for bother',
    add_timestamp_t: 'Add timestamp at the end',
    if_it_t: 'If it disturbs you, please reply "No" and I will not send you any more messages.',
    send_attachments_t: 'Send attachments',
    button_attachments_t: 'Button Message',
    button_text_t: 'Text',
    button_link_t: 'Link',
    button_call_t: 'Call',
    button_text_tip: 'Use | to separate (max 3).',
    button_link_tip: 'Put URL in bracket (max 1). ',
    button_call_tip: 'Put number in bracket (max 1).',
    Example: 'Example',
    image_t: 'Image',
    video_t: 'Video',
    document_t: 'Document',
    contact_t: 'Contact',
    use_placeholder_t: 'Add placeholder from Excel',
    personalized_t: 'Personalized:',
    how_to_use_personalized_t: 'How to use personalized fields',
    group_tools_t: 'Export',
    export_group_t: 'Export group members',
    select_joined_export_t: 'Select joined group to export excel',
    exclude_group_t: 'Exclude group admins',
    download_excel_t: 'Download Excel',
    send_wow_t: 'Send bulk messages to WhatsApp groups:',
    this_feature_t: 'This feature can help you find more related groups.',
    under_development_text_t: 'Under development now, please see the ',
    under_development_link_t: 'tutorial',
    if_you_text_t: 'If you have any questions, please ',
    if_you_link_t: 'Contact us',
    statistics_t: 'Statistics',
    more_tools_t: 'More',
    current_sending_t: 'Current sending progress',
    please_do_t: 'Please do not leave, next message will be sent after',
    every_t:
        'Every 80 messages will be divided into one group, and there will be a 3-5min interval between each two groups.',
    send_results_t: 'Send results',
    too_many_t: 'Too many chats to manage? Help you manage more efficiently.',
    total_t: 'Total',
    deduplicated_t: 'Deduplicated',
    sent_successfully_t: 'Sent successfully',
    failed_to_t: 'Failed to send',
    troubleshooting_t: 'Troubleshooting',
    no_network_t: 'No Network',
    please_click_first_t: 'please click ',
    please_click_second_t: '"Retry Failed"',
    wrong_number_t: 'Wrong number',
    check_the_first_t: "Check the number's ",
    check_the_second_t: 'format',
    check_if_first_t: 'Check if the number is ',
    check_if_second_t: 'real and active',
    pause_t: 'Pause',
    continue_t: 'Continue',
    export_results_t: 'Export results',
    retry_failed_t: 'Retry Failed',
    when_the_t:
        'When the message fails to be sent continuously, please click "Retry failed" button.',
    rate_for_t: 'Rate for us if you like Bulk Sender.',
    please_check_t:
        'Please check the upload Excel and make sure the correct WhatsApp number is filled in the first column.',
    check_the_entered_t: "Checking the number's format you entered. ",
    please_enter_please_t: 'Please enter at least',
    please_enter_one_t: 'one',
    please_enter_number_t: ' number.',
    the_template_t: 'The template has been saved.',
    please_enter_a_t: 'Please enter a message.',
    please_enter_at_t: 'Please enter at least one number.（ ≥ 1 number）',
    safety_1_t: 'Safety Suggestions',
    safety_2_t: 'To avoid your account being banned, we suggest:',
    safety_3_1_t: 'Account has been registered ',
    safety_3_2_t: ' days',
    safety_4_1_t: 'Mobile phone and website ',
    safety_4_2_t: 'IP are in the same area',
    safety_5_1_t: 'Do not ',
    safety_5_2_t: 'switch IP frequently',
    safety_6_t: 'Messages you could send:',
    safety_7_t: '50 max - the first day ',
    safety_8_t: '300 max - from second day ',
    agree_t: 'Agree & Continue',
    donot_t: "Don't show again",
    suggest_1_t: 'To avoid sending failed , we suggest:',
    suggest_2_t: 'Do not switch the chat window.',
    suggest_3_t: 'Stay here while messages are sending automatically.',
    suggest_4_t: 'Only enable Bulk Sender.',
    suggest_5_t:
        'Same type of extension will cause issue. Please close<br>other WhatsApp extensions, only open Bulk Sender.',
    about_t: 'About linked devices.',
    uploading_t: 'Uploading attachment, please wait.',
    image_limit_t: "There's a 30 images/videos limit for each send.",
    size_limit_t: "There's a 16 MB size limit for each image/video you send.",
    choose_t: 'Choose a group before export.',
    you_were_t: 'You were removed from the group chat.',
    failed_connect_1_t: 'Failed to connect to your WhatsApp, please refresh the page to reconnect.',
    failed_connect_2_1_t: 'Otherwise, ',
    failed_connect_2_2_t: ' will not work.',
    sent_at_t: '\nSent At: {{time stamp}}',
    first_time_1_t:
        'First time limit has been reached(50 messages)\n\n300 messages are available at ',
    first_time_2_t: '.',
    second_time_1_t: '300 messages are available at ',
    second_time_2_t: '.',
    send_Group_message_wow: 'Send messages to groups?',
    wow_link_t: 'WA Group Sender',
    wow_link_help:
        '🚀 🚀 can help you send messages to <b>groups, communities</b> and <b>broadcasts.</b>',
    tool_choose_file: 'Choose File Format:',
    tool_export_info: 'Export Info From Group:',
    tool_export_now: 'Export Now',
    tool_export_chat: 'Export Info From ChatList:',
    tool_export_all: 'Export All Contacts Info from ChatList',
    tool_export_no_all: 'Export Unsaved Contacts Info from ChatList',
    tool_export_labels: 'Export Info From Label:', //谷歌翻译
    btn_msg_remind_title: "We're excited to announce a new feature update for [Bulk Sender]!!!",
    btn_msg_remind_1: '🚀 **New Feature: [',
    btn_msg_remind_2: 'Send Button Message',
    btn_msg_remind_3: ']**',
    btn_msg_remind_4: 'Click the button below and we will send you a button message for',
    btn_msg_remind_5: '📱 **Try it now:**',
    btn_msg_remind_6: ' free ',
    btn_msg_remind_7: 'to give you a more intuitive experience.',
    but_msg_remind_button: 'Try it now',

    notWork1: 'Failed to connect to your WhatsApp, please refresh the page to reconnect.',
    notWork2: 'Otherwise, Contacts And Group Number Exporter for WhatsApp will not work.',
    popup: {
        faq: 'FAQ',
        excludeAdmin: 'Exclude Admins',
        fileFormat: 'Choose File Format:',
        labelGroup: 'Export From Group:',
        labelChatList: 'Export Info From ChatList:',
        button: {
            group: 'Export Number From Group',
            contacts: 'Export Contacts',
        },
    },
    review1: {
        title: 'Free To Use ！',
        desc: 'Leave a review to unlock unlimited verification access!',
        tip: 'Currently supports exporting up to 10 times. ',
        button: {
            cancel: 'No,Send Now!',
            contacts: 'Leave a Review',
        },
    },
    review2: {
        groupTitle: "Method 1：Join Group",
        title: 'Method 1：Leave a review',
        desc: 'Rate us and leave a review to unlock unlimited access! 👋',
        step: {
            here: 'Click here',
            1: ' to go to the extension store.',
            2: ' Rate us ⭐️⭐️⭐️⭐️⭐️ and leave a review.',
            3: ' Take a screenshot, save, and upload image.'
        },
        button: {
            submit: 'submit',
            groupJoin: 'Click And Join Group To Unlock',
        },
    },
    review3: {
        tip1: 'Thank you for participating！',
        tip2: 'We will review and grant you unlimited access within 1~5 minutes.'
    },
    MultiAccountLimit: {
        title: "Need to Export from Multiple Accounts? ",
        content1: `Google extension supports up to 3 WhatsApp accounts. 
        For more flexibility, welcome to try our desktop product！<br>
        👉 `,
        contactUsLink: 'https://wadesk.io/',
        contactUs: 'Contact Us For Free Trial'
    },
    MultiDeviceLimit: {
        title: "Need to Export from Multiple Devices? ",
        content1: `Google extension supports up to 3 Devices per account.
        For more flexibility, welcome to try our desktop product！<br>
        👉 `,
        contactUsLink: 'https://wadesk.io/',
        contactUs: 'Contact Us For Free Trial'
    },
    Permission: {
        reachCountLimit: "The maximum export limit has been reached."
    },
    Safety: {
        Suggestions: "Safety Suggestions",
        tip1: "To avoid your account being banned, we suggest:",
        tip2: `Account has been registered <i class="boldFont">≥ 15</i> days`,
        tip3: `Mobile phone and website <i class="boldFont">IP are in the same area</i>`,
        tip4: `<i class="boldFont">Do not</i> switch IP frequently`,
        CouldSend: `Messages you could send:`,
        maxFirstDay: `50 max - the first day `,
        maxSecondDay: `300 max - from second day `,
        AgreeAndContinue: ` Agree & Continue `,
        NotShowAgain: ` Don't show again`,
    },
    Safety2: {
        Suggestions: "To avoid sending failed , we suggest:",
        tip1: "Do not switch the chat window.",
        tip2: `Stay here while messages are sending automatically.`,
        AgreeAndContinue: ` Agree & Continue `,
        NotShowAgain: ` Don't show again`,
    },
}
